import {useCallback, useEffect} from 'react'

import {
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
} from 'shared/constant/lookup/role'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'

const useGetMyFranchise = (approved) => {
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest, isLoading] = useFetch()

	const refetch = useCallback(() => {
		if (
			userRole === ROLE_FRANCHISE_MANAGER ||
			userRole === ROLE_STORE_MANAGER
		) {
			let url = `/admin/franchise/my${approved ? '?has_approved=true' : ''}`
			fetchRequest('GET', url)
		}
	}, [userRole])

	useEffect(() => {
		refetch()
	}, [refetch])

	return [fetchResult, isLoading, refetch]
}

export default useGetMyFranchise
